import { OPEN_DROPDOWN, CLOSE_DROPDOWN, DROPDOWN_CLOSED } from "./constants";

export const openDropdown = name => ({ type: OPEN_DROPDOWN, name });

export const closeDropdown = name => ({ type: CLOSE_DROPDOWN, name });

export const dropdownClosed = name => ({ type: DROPDOWN_CLOSED, name });
